import { FixedPriceType } from '../config/registrationConfig'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    fixedPriceTypes: FixedPriceType[]
    getFixedPriceType: (id: string) => FixedPriceType
}

export default function useFixedPriceTypes(): ReturnProps {
    const { loaded, entities } = useGlobalContext('fixedPriceTypes')

    const fixedPriceTypes: FixedPriceType[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )
    const getFixedPriceType = (id: string) => fixedPriceTypes.find(value => value.id === id)

    return { loaded, fixedPriceTypes, getFixedPriceType }
}
